import React from 'react';
import classNames from 'classnames';
import Select from '../../form/Select';
import InfoIcon from '../../../assets/images/error-float-icon.svg';

const FloatActionStage = ({
	children,
	managementCompanyFacilitiesOptions,
	shiftStructureOptions,
	unitsOptions,
	selectedFacilityId,
	selectedShiftStructure,
	selectedUnit,
	onSelectOption,
	onSelectStructure,
	onSelectUnit,
	error
}) => {
	const field = error?.field;

	const unitHasError = field === 'unit_id';
	const shiftTypeHasError = field === 'shift_structure' || field === 'specialties' || field === 'licenses';
	const facilityHasError = !!error && !unitHasError && !shiftTypeHasError;
	return (
		<>
			{children}
			<section className="float-action-section">
				<div className="select-label">Float to</div>
				<Select
					placeholder="Select facility..."
					name="facility"
					className={classNames('select', { 'has-error': facilityHasError })}
					value={selectedFacilityId}
					handleChange={onSelectOption}
					options={managementCompanyFacilitiesOptions}
				/>

				<div className="select-option-container">
					<div className="select-label">Shift type</div>
					<Select
						placeholder="Select shift type..."
						name="structure"
						className={classNames('select', { 'has-error': shiftTypeHasError })}
						value={selectedShiftStructure}
						handleChange={onSelectStructure}
						options={shiftStructureOptions}
					/>
				</div>

				{unitsOptions.length > 0 && (
					<div className="select-option-container">
						<div className="select-label">
							Unit assignment <i>(optional)</i>
						</div>
						<Select
							placeholder="Select unit..."
							name="unit"
							className={classNames('select', { 'has-error': unitHasError })}
							value={selectedUnit}
							handleChange={onSelectUnit}
							options={unitsOptions}
						/>
					</div>
				)}

				{error && (
					<div className="error-banner">
						<div className="error-banner__icon">
							<img src={InfoIcon} alt="error" />
						</div>
						<div className="error-banner__text">{error.message}</div>
					</div>
				)}
			</section>
		</>
	);
};

export default FloatActionStage;
